module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"AddToCart":{"button":"Koupit","variantRequired":"Prosím vyberte variantu","notAvailable":"Není skladem","variantDoesNotExist":"Tato varianta neexistuje"}}}')
  delete Component.options._Ctor
}
